import React, { Component } from 'react';
import Home from '../home/home';
import './app.css';


class App extends Component {

    constructor() {
        super()
        this.state = {

        }
    }

    render() {
        return <Home />;
    }
}
export default App;